// source: analysis_availability.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.displayName = 'proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.displayName = 'proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest;
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.toObject = function(includeInstance, msg) {
  var f, obj = {
iccBookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
bookTitle: jspb.Message.getFieldWithDefault(msg, 2, ""),
bookAbbreviation: jspb.Message.getFieldWithDefault(msg, 3, ""),
applicabilityAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
complianceAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
lastAnalysisDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
applicableSectionsCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
complianceReportsCount: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability;
  return proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccBookId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBookAbbreviation(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplicabilityAvailable(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setComplianceAvailable(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastAnalysisDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setApplicableSectionsCount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setComplianceReportsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccBookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBookTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBookAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getApplicabilityAvailable();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getComplianceAvailable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLastAnalysisDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getApplicableSectionsCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getComplianceReportsCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string icc_book_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getIccBookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setIccBookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string book_title = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getBookTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setBookTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string book_abbreviation = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getBookAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setBookAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool applicability_available = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getApplicabilityAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setApplicabilityAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool compliance_available = 5;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getComplianceAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setComplianceAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string last_analysis_date = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getLastAnalysisDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setLastAnalysisDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 applicable_sections_count = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getApplicableSectionsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setApplicableSectionsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 compliance_reports_count = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.getComplianceReportsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.prototype.setComplianceReportsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
availableBooksList: jspb.Message.toObjectList(msg.getAvailableBooksList(),
    proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.toObject, includeInstance),
totalBooksChecked: jspb.Message.getFieldWithDefault(msg, 2, 0),
processingTimeMs: jspb.Message.getFieldWithDefault(msg, 3, 0),
hasAnalysis: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
summary: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse;
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.deserializeBinaryFromReader);
      msg.addAvailableBooks(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalBooksChecked(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProcessingTimeMs(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAnalysis(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAvailableBooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.serializeBinaryToWriter
    );
  }
  f = message.getTotalBooksChecked();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getProcessingTimeMs();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated BookAnalysisAvailability available_books = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability>}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.getAvailableBooksList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.setAvailableBooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.addAvailableBooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.clearAvailableBooksList = function() {
  return this.setAvailableBooksList([]);
};


/**
 * optional int32 total_books_checked = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.getTotalBooksChecked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.setTotalBooksChecked = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 processing_time_ms = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.getProcessingTimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.setProcessingTimeMs = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool has_analysis = 4;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.getHasAnalysis = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.setHasAnalysis = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.clearHasAnalysis = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.hasHasAnalysis = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string summary = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisResponse.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.toObject = function(includeInstance, msg) {
  var f, obj = {
pageNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
availableBooksList: jspb.Message.toObjectList(msg.getAvailableBooksList(),
    proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability;
  return proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.deserializeBinaryFromReader);
      msg.addAvailableBooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAvailableBooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page_number = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated BookAnalysisAvailability available_books = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability>}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.getAvailableBooksList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} returns this
*/
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.setAvailableBooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.addAvailableBooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.service.analysis.BookAnalysisAvailability, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.prototype.clearAvailableBooksList = function() {
  return this.setAvailableBooksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest;
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagesWithAnalysisList: jspb.Message.toObjectList(msg.getPagesWithAnalysisList(),
    proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.toObject, includeInstance),
totalPagesChecked: jspb.Message.getFieldWithDefault(msg, 2, 0),
analyzedPagesCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalBooksChecked: jspb.Message.getFieldWithDefault(msg, 4, 0),
processingTimeMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
hasAnalysis: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
summary: jspb.Message.getFieldWithDefault(msg, 7, ""),
lastUpdated: jspb.Message.getFieldWithDefault(msg, 8, ""),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 9, ""),
totalPagesInProject: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse;
  return proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.deserializeBinaryFromReader);
      msg.addPagesWithAnalysis(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPagesChecked(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAnalyzedPagesCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalBooksChecked(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProcessingTimeMs(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAnalysis(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastUpdated(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPagesInProject(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagesWithAnalysisList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability.serializeBinaryToWriter
    );
  }
  f = message.getTotalPagesChecked();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAnalyzedPagesCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalBooksChecked();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProcessingTimeMs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLastUpdated();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTotalPagesInProject();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * repeated PageAnalysisAvailability pages_with_analysis = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability>}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getPagesWithAnalysisList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability>} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setPagesWithAnalysisList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.addPagesWithAnalysis = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.service.analysis.PageAnalysisAvailability, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.clearPagesWithAnalysisList = function() {
  return this.setPagesWithAnalysisList([]);
};


/**
 * optional int32 total_pages_checked = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getTotalPagesChecked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setTotalPagesChecked = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 analyzed_pages_count = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getAnalyzedPagesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setAnalyzedPagesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_books_checked = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getTotalBooksChecked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setTotalBooksChecked = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 processing_time_ms = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getProcessingTimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setProcessingTimeMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool has_analysis = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getHasAnalysis = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setHasAnalysis = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.clearHasAnalysis = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.hasHasAnalysis = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string summary = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string last_updated = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getLastUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setLastUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string next_page_token = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 total_pages_in_project = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.getTotalPagesInProject = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.analysis.GetAvailableAnalysisForProjectResponse.prototype.setTotalPagesInProject = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service.analysis);
